exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trophy-wrapper {\n  display: inline-block;\n  margin: 0px 1px; }\n  .trophy-wrapper svg {\n    display: inline-block;\n    vertical-align: middle; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/trophy/trophy.component.scss
// module id = ../../../../../src/app/common/trophy/trophy.component.scss
// module chunks = main